import { GetProductArrangementsQuery } from 'data/__generated__';
import { GET_PRODUCT_ARRANGEMENTS_QUERY } from 'data/queries/productArrangement';
import { apolloClient } from '../../../App';

export const deletedProductArrangementsHandler = (deletedProductArrangementIds: string[]) => {
    let currentProductArrangements = [] as GetProductArrangementsQuery['productArrangementsQuery'];
    // We can read query only if it has been run
    try {
        const result = apolloClient.readQuery<GetProductArrangementsQuery>({ query: GET_PRODUCT_ARRANGEMENTS_QUERY });
        if (!result) {
            throw Error('An error occurred when reading GET_SUPPLY_ORDERS_QUERY');
        }
        currentProductArrangements = result.productArrangementsQuery;
    } catch {
        // do nothing
    }

    const newProductArrangements = currentProductArrangements.filter(
        (productArrangement) => !deletedProductArrangementIds.includes(productArrangement._id),
    );

    apolloClient.writeQuery({
        query: GET_PRODUCT_ARRANGEMENTS_QUERY,
        data: { productArrangementsQuery: newProductArrangements },
    });
};

export const productArrangementsUpdatedOrCreatedHandler = (
    productArrangementsUpdatedOrCreated: GetProductArrangementsQuery['productArrangementsQuery'],
) => {
    let currentProductArrangements = [] as GetProductArrangementsQuery['productArrangementsQuery'];
    // We can read query only if it has been run
    try {
        const result = apolloClient.readQuery<GetProductArrangementsQuery>({ query: GET_PRODUCT_ARRANGEMENTS_QUERY });
        if (!result) {
            throw Error('An error occurred when reading GET_SUPPLY_ORDERS_QUERY');
        }
        currentProductArrangements = result.productArrangementsQuery;
    } catch {
        // do nothing
    }

    const updatedOrCreatedProductArrangementIds = productArrangementsUpdatedOrCreated.map(({ _id }) => _id);
    const nonUpdatedOrCreatedProductArrangements = currentProductArrangements.filter(
        ({ _id }) => !updatedOrCreatedProductArrangementIds.includes(_id),
    );
    const newProductArrangements = [...productArrangementsUpdatedOrCreated, ...nonUpdatedOrCreatedProductArrangements];

    apolloClient.writeQuery({
        query: GET_PRODUCT_ARRANGEMENTS_QUERY,
        data: { productArrangementsQuery: newProductArrangements },
    });
};
